export const SLIDER_CONFIG_SUGGESTION_LOCATION = {
  dots: true,
  infinite: false,
  speed: 800,
  slidesToShow: 2,
  slidesToScroll: 2,
  variableWidth: true,
  autoplay: false,
  arrows: false,
  adaptiveHeight: true,
};
